var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 10C9.11929 10 8 11.1193 8 12.5V37.5C8 38.8807 9.11929 40 10.5 40H50.5C51.8807 40 53 38.8807 53 37.5V12.5C53 11.1193 51.8807 10 50.5 10H10.5ZM3 12.5C3 8.35786 6.35786 5 10.5 5H50.5C54.6421 5 58 8.35786 58 12.5V37.5C58 41.6421 54.6421 45 50.5 45H10.5C6.35786 45 3 41.6421 3 37.5V12.5Z",
    fill: "#8C041C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 52.5C18 51.1193 19.1193 50 20.5 50H40.5C41.8807 50 43 51.1193 43 52.5C43 53.8807 41.8807 55 40.5 55H20.5C19.1193 55 18 53.8807 18 52.5Z",
    fill: "#8C041C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 40C31.8807 40 33 41.1193 33 42.5V52.5C33 53.8807 31.8807 55 30.5 55C29.1193 55 28 53.8807 28 52.5V42.5C28 41.1193 29.1193 40 30.5 40Z",
    fill: "#8C041C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.4c11ca450ae00b968ff6b8ca04fc01e5.svg";
export { ForwardRef as ReactComponent };